// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"videoTile-module--wrapper--14W7R","block":"videoTile-module--block--2GXwW","videoResponsive":"videoTile-module--videoResponsive--SLQPt"};